module.exports = __webpack_public_path__ + "static/media/mode-62.90f60f94.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-62.svg
// module id = 1016
// module chunks = 2